<template>
  <div>
    <Card>
      <p slot="title"> Penyesuaian Nota Transaksi </p>

        <Form ref="formNT" :label-width="120" :rules="ruleValidate">
          <Form-item label="Type" prop="type">
              <Select v-model="category" placeholder="Pilih Kategori Bank" @on-change="checkValidation()">
                  <Option v-for="category in categories" :value="category.id" :key="category.id">{{
                      category.value }}
                  </Option>
              </Select>
          </Form-item>
          <Form-item label="Akun Bank" prop="bankAccountId">
              <Select v-model="bankAccountId" placeholder="Pilih Rekening Bank" @on-change="checkValidation()" clearable filterable>
                  <Option
                      v-for="bankAccount in bankAccounts"
                      :value="bankAccount.id"
                      :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
              </Select>
          </Form-item>
          <Form-item label="Nomor NT Lama" prop="noteCode">
              <Select filterable placeholder="Nomor Giro Lama" v-model="formNT.noteCode" @on-change="checkForm()">
                  <Option v-for="(option, index) in listNT" :value="option.noteCode" :key="index">
                      {{ option.noteCode }}</Option>
              </Select>
          </Form-item>
          <Form-item label="Nomor NT Baru" prop="noteCodeOld" >
              <Select filterable placeholder="Nomor Giro Baru" v-model="formNT.noteCodeOld" @on-change="checkForm()">
                  <Option v-for="(option, index) in listNT" :value="option.noteCode" :key="index">
                      {{ option.noteCode }}</Option>
              </Select>
          </Form-item>
          <Form-item>
              <Button type="success" @click="handleSubmit('formNT')" v-show="isReady">Save</Button>
              <Button type="error" @click="clearForm()" >Cancel</Button>
          </Form-item>
        </Form>

    </Card>
  </div>
</template>

<script>
  import {HTTP} from '@/components/http-lib'
  import _ from 'lodash'


  export default {
    name: 'AdjustmentNoteCode',
    data() {
      return {
        bankAccountId: null,
        bankAccounts: [],
        category: null,
        isReady: false,
        categories: [
          {
              id : 'MUTASI',
              value : 'MUTASI'
          },
          {
              id : 'GIRO',
              value : 'GIRO'
          },
          {
              id : 'PENYESUAIAN',
              value : 'PENYESUAIAN'
          }
        ],
        formNT: {
          noteCode: '',
          noteCodeOld: ''
        },
        listNT: [],
        ruleValidate: {
            bankAccountId: [
                { required: true, message: 'Akun Bank', trigger: 'change' }
            ],
            noteCode: [
                { required: true, message: 'Nomor NT Lama', trigger: 'change' }
            ],
            noteCodeOld: [
                { required: true, message: 'Nomor NT Baru', trigger: 'change' }
            ]
        },
      }
    },
    mounted() {
      this.getBankAccount();
    },
    methods: {
      checkValidation() {
       if(this.bankAccountId && this.category){
        this.getListNT();
       }
      },
      checkForm() {
        console.log("checkForm", this.formNT.noteCode, this.formNT.noteCodeOld);

        if(this.formNT.noteCode && this.formNT.noteCodeOld) {
          this.isReady = true;
        } else {
          this.isReady = false;
        }
      },
      clearForm() {
        this.bankAccountId = null;
        this.category = null;
        this.formNT.noteCode = null;
        this.formNT.noteCodeOld = null;
        this.listNT = [];
        this.isReady = false;
      },
      getBankAccount: function() {
        HTTP.get("bankAccount/findAll/active")
          .then(response => {
            this.bankAccounts = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
      },
      getListNT: function() {
         HTTP
          .post("paymentPending/list-nota", {
            category: this.category,
            bankAccountId : this.bankAccountId
          })
          .then(response => {
            this.listNT = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
      },
      setNoteTransaction: function() {
         HTTP
          .post("transaction-note/adjustment", {
            bankAccountId: this.bankAccountId,
            old_note_code: this.formNT.noteCode,
            new_note_code : this.formNT.noteCodeOld
          })
          .then(response => {
            response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
      },
      handleSubmit (name) {
        this.setNoteTransaction();
      },
    }
  }


</script>




// WEBPACK FOOTER //
// AdjustmentNoteCode.vue?7093e3fc